import { useTranslation } from "react-i18next";

import "./RecoverPassword.scss";

const RecoverRequestConfirmation: React.FC = () => {
  const { t } = useTranslation();

  return (
    <>
      <div className="sign-up-confirmation__caption">
        <p className="sign-up-confirmation__caption-title">
          {t("signUp.recoveryPasswordConfirmationSection.title")}
        </p>
      </div>
    </>
  );
};

export default RecoverRequestConfirmation;
